window.theme = window.theme || {};
let objectWithSKU = {};
let skuForUse = [];
let productsSKU = {};
// Searchanise Tech Team Code
document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
      // let objectWithSKU = {};
          //custom discounts by customer tags
          let discountTags = {
              'platinum': 0.10,
              'guestgold': 0.05,
              'gold': 0.10
          }
          
          let customerTags = window.snizeCustomerTags.toLowerCase().split(',');
          let discountLevel, customerTierLevel;
  
          for (const tag of customerTags) {
            discountLevel = discountTags[tag];
            if (discountLevel) {
              customerTierLevel = tag;
              break;
            }
          }

          customerTierLevel = customerTierLevel.toLowerCase();
      
          $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
              if (!data.items || !data.items.length)
                  return;

           
            
              data.items.forEach(function (el, index) {
              let cfpLevel; 

              let tags = el.tags.split('[:ATTR:]');

              if (tags.includes("Perigold") || tags.includes("ProSource") || tags.includes("DHC") || tags.includes("ACN")){
                cfpLevel = true;
              } else {
                cfpLevel = false;
              } 

              if(cfpLevel) return;
              if (discountLevel) {
                let oldPrice = el.price;
                // data.items[index].price = Math.round(el.price * (1 - discountLevel) * 100) / 100;
                
                let newPrice = Math.round(el.price * (1 - discountLevel) * 100) / 100;
                
               
                // Pull out the product 
                let productTags = tags;
               
                       
              ////////////// brandon new /////////////////////
                let targetTago; 
                if (customerTierLevel == "guestgold"){
                  targetTago = "AvgFG";
                } else if (customerTierLevel == "gold"){
                  targetTago = "AvgFG";
                } else if (customerTierLevel == "platinum"){
                  targetTago = "AvgFG";
                }  

                let avgFG;
                productTags.forEach(tag => {
                  const tagArray = tag.split(":");
                 
                  if (tagArray[0] === targetTago) {
                    avgFG = parseFloat(tagArray[1]);
                  }
                });

                ////////////////////////////////////////////////////            
                
               
                
                // Calculate the final price
                newPrice = newPrice * 100;
                let finalPrice = newPrice ;

                // Replace the Variant Compare Price with New Product tags
                // going back to variant compare instead of tag avgFG
                //if (avgFG) {
                  //data.items[index].list_price = avgFG;
               // }

                data.items[index].price = finalPrice / 100;
                data.items[index].discount = Math.round(100 * (1 - data.items[index].price / data.items[index].list_price));
  
                if (el.shopify_variants && el.shopify_variants.length) {
                  el.shopify_variants.forEach(function (variant, varIndex) {
                    if (variant.price == oldPrice) {
                      data.items[index].shopify_variants[varIndex].price = data.items[index].price;
                      if (avgFG) data.items[index].shopify_variants[varIndex].list_price = data.items[index].list_price;
                    }
                  });
                }
              } 
            });
          });
        //custom discounts by customer tags end

      $(document).on('Searchanise.ResultsUpdated', function (event, container) {
          function waitUntilGeeneeCloseDefined(button) {
              if (button) {
                  button.click(function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      $('.modal_truck').hide();
                  });
              } else {
                  setTimeout(waitUntilGeeneeCloseDefined, 100);
              }
          }

        <!--------- Public Price here ---------------->
                     
          setTimeout(function () {

              $('.snize-product', container).each(function () {
                  let product = $(this);
                  let productData = product.data('snize_item_data');
                 

                  if ($('.snize-discounted-price', this).length) {
                     
                      if (!$('.snize-price-list-price', this).length) {
                          $('.snize-discounted-price', this).after(`<span class="snize-price-list-price">Public Price</span>`);
                      }
                      let snizeRegularPrice = productData.list_price;
                    
                      let snizeDiscPrice = productData.price;
                   
                      let snizePriceDifference = Math.round((100 * (snizeRegularPrice - snizeDiscPrice)) / snizeRegularPrice);
                      if (snizePriceDifference && !$('.snize-price-difference', this).length) {
                          //$('.snize-price-list ', this).append(`<span class="snize-price-difference">${snizePriceDifference + "% off"}</span>`);
                        
                     }
                  }
      
                  let snizeSKUMetafield = productData.metafield_a673369177a48bd3929968799dedba09 ?
                      productData.metafield_a673369177a48bd3929968799dedba09 :
                      '';
                  $(product).attr('data-image', $('.snize-thumbnail img', this).attr('src'));
                  if (!$('.genieprice', this).length) {
                      $(this).append(`
                                  <fg-trigger class="tool-tip-trigger genieprice" data-tool-tip-trigger="" data-tool-tip="id04-${productData.product_id}">
                                    <button type="button" class="fg-trigger__button">
                                      <img loading="lazy" width="294" height="50" src="${theme.strings.fgButton}"></span>
                                    </button>
                                    <template class="tool-tip-trigger__content rte" data-tool-tip-content="">
                                      <fg-modal-frame id="modal-frame" data-frame-source="https://api.membersdirect.com/fg.php?sku=${productData.add_to_cart_sku}&cid=${window.snizeCustomerID}"></fg-modal-frame>
                                    </template>
                                  </fg-trigger>`);
                  }
                  if (snizeSKUMetafield && !$('.snize-custom-options-box', this).length) {
                      $('.snize-options-box:not(.snize-custom-options-box)', this).remove();
                      //if (!$('.snize-custom-options-box', this).length) {
                      $('.snize-description', this).after(`<div class="snize-options-box snize-custom-options-box">
                                              <div class="snize-color-swatch-box snize-swatch-type-image"><input type="hidden" name="Color" value="Pink" class="snize-option snize-option-color"></div><div class="snize-size-select-box"><input type="hidden" name="Size" value="Queen" class="snize-option snize-option-size"></div></div>`);
                      //}
                      productsSKU[productData.product_id] = snizeSKUMetafield.split('|');
                      productsSKU[productData.product_id].filter(id => id);
                      skuForUse.push(productData.add_to_cart_sku);
                      productsSKU[productData.product_id].push(productData.add_to_cart_sku);
                      snizeSKUMetafield.split('|').forEach(function (sku) {
                          if (sku) {
                              skuForUse.push(sku);
                          }
                      });
                  }
                  $('.genieprice').click(function (ev) {
                      waitUntilGeeneeCloseDefined($('.close_reward', this));
                  });
              });
              skuForUseUnique = [...new Set(skuForUse)];
              skuForUseUnique.forEach(function (sku) {
                  if (!objectWithSKU.hasOwnProperty(sku)) {
                      $.getJSON(`/products/${sku}`).done(function (data) {
                          let tags = data.product.tags;
                          let cfpLevel;
                          if (tags.includes("Perigold") || tags.includes("ProSource") || tags.includes("DHC") || tags.includes("ACN")) {
                              cfpLevel = true;
                          } else {
                              cfpLevel = false;
                          }

                          
      
                          let skuValue = data.product.options[0].values[0];
                          let imageURL = data.product.image.src;
                          let skuID = data.product.variants[0].id;
                          let skuTitle = data.product.title;
                          let skuOptions = data.product.options;
                          let skuvariants = data.product.variants;
      
                          var skuPrice,
                              newPrice;
                          if (cfpLevel) {
                              skuPrice = data.product.variants[0].price;
                          } else {
                              newPrice = discountLevel ? Math.round(data.product.variants[0].price * (1 - discountLevel) * 100) / 100 : data.product.variants[0].price;

                           

                           
                            

                            
                            // Calculate the final price
                            newPrice = newPrice * 100;
                            let finalPrice = newPrice ;
                            skuPrice = finalPrice / 100;
                          }
                        
                          let skuDiscountedPrice = data.product.variants[0].compare_at_price ? data.product.variants[0].compare_at_price : '';
                          let optionName = data.product.options[0].name;
                          objectWithSKU[sku] = {
                              'sku': sku,
                              'name': optionName,
                              'color': skuValue,
                              'image': imageURL,
                              'sku_id': skuID,
                              'title': skuTitle,
                              'sku_price': skuPrice,
                              'sku_discounted_price': skuDiscountedPrice,
                              'options': skuOptions,
                              'variants': skuvariants,
                          };
                      });
                  }
              })
              for (el of Object.keys(productsSKU)) {
                  let product = $(`#snize-product-${el}`);
                  let defaultData = product.data('snize_item_data');
                  product.off().on('mouseleave', function (event) {
                      product.attr('data-image', defaultData.image_link.replace('https:', ''));
                      product.attr('data-product-variant', defaultData.add_to_cart_id);
                      $('.snize-title', product).text(defaultData.title);
                      $('.snize-price-with-discount', product).text(Searchanise.GetWidgets().formatPrice(defaultData.price));
                      $('.snize-discounted-price', product).text(Searchanise.GetWidgets().formatPrice(defaultData.list_price));
                      $('.snize-view-link', product).attr('href', `/products/${defaultData.add_to_cart_sku}?variant=${defaultData.add_to_cart_id}`);
                      $('.snize-item-image ', product).attr('src', defaultData.image_link);
                      $('.genieprice template', product).remove();
                      $('.genieprice', product).append(`
                    <template class="tool-tip-trigger__content rte" data-tool-tip-content="">
                    <fg-modal-frame id="modal-frame" data-frame-source="https://api.membersdirect.com/fg.php?sku=${defaultData.add_to_cart_sku}&cid=${window.snizeCustomerID}"></fg-modal-frame>
                    </template>`);
                      $('.genieprice', product).off().on('click', function (event) {
                          document.dispatchEvent(new CustomEvent('fgmodal:open', {
                              detail: {
                                  context: $('[tool-tip-trigger]', product).attr('data-tool-tip'),
                                  content: new DOMParser().parseFromString($('[data-tool-tip-content]', product).html(), 'text/html')
                              },
                              bubbles: true
                          }
                          ))
                      })
                  });
                  productsSKU[el].forEach(function (sku) {
                      function waitUntilDefined() {
                          if (objectWithSKU.hasOwnProperty(sku)) {
                              let skuData = objectWithSKU[sku];
                              if (objectWithSKU[sku].name == 'Color' && !$(`.snize-color-swatch[snize-meta-variant="${skuData.variants[0].id}"]`, product).length) {
                                  $('.snize-color-swatch-box', product).append(`<div class="snize-color-swatch" data-value="${skuData.options[0].values[0]}" title=${skuData.options[0].values[0]} snize-meta-variant=${skuData.variants[0].id}>
                                      <span class="" style="background-color: rgb(255, 192, 203); background-image: url(${skuData.image.replace('.jpg', '_50x50.jpg')});"></span>
                                  </div>`);
                                  $(`.snize-color-swatch-box:not(.snize-thumbnail-image-box) .snize-color-swatch[data-value="${skuData.options[0].values[0]}"]`, product).off().on('mouseover', function (event) {
                                      product.attr('data-image', skuData.image.replace('https:', ''));
                                      product.attr('data-product-variant', skuData.variants[0].id);
                                      $('.snize-title', product).text(skuData.title);
                                      $('.snize-price-with-discount', product).text(Searchanise.GetWidgets().formatPrice(skuData.sku_price));
                                      $('.snize-discounted-price', product).text(Searchanise.GetWidgets().formatPrice(skuData.sku_discounted_price));
                                      $('.snize-view-link', product).attr('href', `/products/${sku}?variant=${skuData.variants[0].id}`);
                                      $('.snize-item-image ', product).attr('src', skuData.image);
                                      $('.genieprice template', product).remove();
                                      $('.genieprice', product).append(`
                                    <template class="tool-tip-trigger__content rte" data-tool-tip-content="">
                                    <fg-modal-frame id="modal-frame" data-frame-source="https://api.membersdirect.com/fg.php?sku=${sku}&cid=${window.snizeCustomerID}"></fg-modal-frame>
                                    </template>`);
                                      $('.genieprice', product).off().on('click', function (event) {
                                          document.dispatchEvent(new CustomEvent('fgmodal:open', {
                                              detail: {
                                                  context: $('[tool-tip-trigger]', product).attr('data-tool-tip'),
                                                  content: new DOMParser().parseFromString($('[data-tool-tip-content]', product).html(), 'text/html')
                                              },
                                              bubbles: true
                                          }
                                          ))
                                      });
                                  });
                                  if (skuData.variants[0].id == product.attr('data-product-variant')) {
                                      $(`.snize-color-swatch[snize-meta-variant=${product.attr('data-product-variant')}]`, product).addClass('snize-color-swatch-active');
                                  }
                              } else if (skuData.name == 'Color' || !$('.snize-color-swatch-box .snize-size', product).length) {
                                  $('.snize-size-select-box', product).append(`<div class="snize-size" data-value="${skuData.options[0].values[0]}" snize-meta-variant=${skuData.variants[0].id}>${skuData.options[0].values[0]}</div>`);
                                  $(`.snize-size[data-value="${skuData.options[0].values[0]}"]`).off().on('click', function () {
                                      $('.snize-title', product).text(skuData.title);
                                      product.attr('data-product-variant', skuData.variants[0].id);
                                      $('.snize-view-link', product).attr('href', `/products/${sku}?variant=${skuData.variants[0].id}`);
                                      $('.snize-item-image ', product).attr('src', skuData.image);
                                      //$('.snize-price-with-discount', product).text(Searchanise.GetWidgets().formatPrice(data.product.variants[0].price));
                                      //$('.snize-discounted-price', product).text(Searchanise.GetWidgets().formatPrice(data.product.variants[0].compare_at_price));
                                      $('.genieprice template', product).remove();
                                      $('.genieprice', product).append(`
                                  <template class="tool-tip-trigger__content rte" data-tool-tip-content="">
                                    <fg-modal-frame id="modal-frame" data-frame-source="https://api.membersdirect.com/fg.php?sku=${sku}&cid=${window.snizeCustomerID}"></fg-modal-frame>
                                  </template>`);
                                  });
                                  if (skuData.variants[0].id == product.attr('data-product-variant')) {
                                      $(`.snize-size[snize-meta-variant=${product.attr('data-product-variant')}]`, product).addClass('snize-size-active');
                                  }
                              }
                          } else {
                              setTimeout(waitUntilDefined, 100);
                          }
                      }
                      waitUntilDefined();
                  })
              }
          }, 0);
      });

    })(window.Searchanise.$);
});

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        $(document).on("Searchanise.ResultsUpdated", function() {
            $('.snize-search-results .snize-product').each(function() {
                var snizeCurrentProduct = $(this);
                if ($('.snize-color-swatch', snizeCurrentProduct).length > 5 && !$('.snize-color-swatches-show-more', snizeCurrentProduct).length) {
                    $('.snize-color-swatch-box', snizeCurrentProduct).append(`<span class="snize-color-swatches-show-more">+${$('.snize-color-swatch', snizeCurrentProduct).length - 5}</span>`);
                    $('.snize-color-swatches-show-more', snizeCurrentProduct).on('click', function(e) {
                        e.preventDefault();
                        $('.snize-color-swatch', snizeCurrentProduct).css('display', 'inline-block');
                        $('.snize-color-swatches-show-more', snizeCurrentProduct).remove();
                    })
                }
            });
        });
    })(window.Searchanise.$);
});
// Code End Here

document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
      $(document).on('Searchanise.ResultsUpdated', function(event, container) {
          setTimeout(function() {
              $('.snize-product', container).each(function() {
                  let product = $(this);
                  let productData = product.data('snize_item_data');
                  let productURL = productData.link;
                  let snizeSKUImages = productData.shopify_images;
                  let productMetafieldRedirection = productData.metafield_a673369177a48bd3929968799dedba09;

                  let hasMSRPTag = false;
                  let productTags = productData.tags.split('[:ATTR:]');

                  if(productTags.includes('ProSource')){
                    hasMSRPTag = true;
                  }

               
                

                  if(hasMSRPTag) {
                    //$('.snize-price', this).addClass('snize-msrp-price-through');
                    if ($('.snize-discounted-price', this).length && $('.snize-price-difference', this).length) {
                      //$('.snize-discounted-price', this).addClass('hide'); ////brandon commented out
                      //$('.snize-price-difference', this).addClass('hide'); //brandon commented out
                    }
                  }
                
                  if(!product) return;
                  // $.getJSON(productURL+'.js', function(data){
                  //   product.attr('data-image',data.featured_image);
                  // });

                  // if($(this).find('.snize-reviews').length == 0) {
                  //   var snizeReview = `<div class="snize-reviews"><div product-id="${productData.product_id}" product-handle="${productData.link}" class="alireviews-review-star-rating"></div></div>`;
                  //   $(this).find('.snize-overhidden').append(snizeReview);
                  // }
                  
                  if($(this).find('.ProductCard-shipping').length == 0) {
                    var snizeShippingContent = `<div class="snize-product__shipping ProductCard-shipping text-left">
                      <p class="ProductCard-freeShipping FastShipping">
                        <span>FREE Shipping</span>
                      </p>
                    </div>`;
                    $(this).append(snizeShippingContent);
                  }
                
                if(productMetafieldRedirection) return;
                  
                  if($(this).find('.snize-custom-options-box').length === 0) {
                      $(this).find('.snize-options-box').remove();

                    if($(this).find('.snize-thumbnail-image-box').length === 0) {  
                      $(this).find('.snize-description').after(`<div class="snize-color-swatch-box snize-swatch-type-image snize-thumbnail-image-box"></div>`);

                      var snizeitemImages = '';
                        for(q=0; q<snizeSKUImages.length; q++) {
                          if(q < 5) {
                            snizeitemImages  = snizeitemImages + 
                            `<div class="snize-color-swatch" data-image="${snizeSKUImages[q]}">
                                <span style="background-image: url(${snizeSKUImages[q]});">
                                </span>
                              </div>`;
                          }
                        }
                      $(this).find('.snize-thumbnail-image-box').append(snizeitemImages);
                      $(this).find('.snize-color-swatch:eq(0)').addClass('snize-color-swatch-active');
                    }
                  }      
              });
          }, 0)
      })

    // Image Change Based on Mouse Event
    $('body').on('mouseenter','.snize-thumbnail-image-box .snize-color-swatch', function(){  
      $(this).siblings().removeClass('snize-color-swatch-active');
      $(this).removeClass('snize-color-swatch-active');
      $(this).addClass('snize-color-swatch-active');
      var image = $(this).attr('data-image');
      var grid = $(this).closest('.snize-product');        
      $(grid).find('.snize-thumbnail-wrapper img').attr('src', image);
    });
    
    $('body').on('click','.snize-thumbnail-image-box .snize-color-swatch', function(){  
      $(this).siblings().removeClass('snize-color-swatch-active');
      $(this).removeClass('snize-color-swatch-active');
      $(this).addClass('snize-color-swatch-active');
      var image = $(this).attr('data-image');
      var grid = $(this).closest('.snize-product');        
      $(grid).find('.snize-thumbnail-wrapper img').attr('src', image);
    });
    
    $('body').on('mouseleave','.snize-product', function(){ 
      $(this).find('.snize-thumbnail-image-box .snize-color-swatch').removeClass('snize-color-swatch-active');
      $(this).find('.snize-thumbnail-image-box .snize-color-swatch:eq(0)').addClass('snize-color-swatch-active');
      var imageWrapper = $(this).find('.snize-thumbnail-wrapper');
      var featured_image = $(this).attr('data-image');
      $(this).find(imageWrapper).find('img').attr('src', featured_image);              
    });
    
  }
  )(window.Searchanise.$)
});